"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Skeleton.module.css";

export interface SkeletonProps extends Omit<HTMLProps<HTMLElement>, "size"> {
	loading?: boolean;
}

export default function Skeleton({
	loading,
	children,
	className,
	...props
} : SkeletonProps) {
	return (
		<span
			className={cn(
				styles.Skeleton,
				loading ? styles.Skeleton_loading : null,
				className
			)}
			{...props}
		>
			<span>
				{children}
			</span>
		</span>
	);
}